import { Component, h, Prop, Host, State, Watch } from '@stencil/core';
import { ProductPriceItem } from '../../../globals/shared/productprice/product-price-types';
import { state } from './pn-product-pricelist-store';
import { sendDirectUrl, stampShopUrl } from './data.js';
import { bolt, box_label } from 'pn-design-assets/pn-assets/icons.js';

@Component({
  tag: 'pn-product-pricelist-result',
  styleUrl: 'pn-product-pricelist-result.scss',
})
export class PnFindProductPricelistResult {
  @Prop({ mutable: true }) item: ProductPriceItem = null;
  @Prop() description?: string[] = [];
  @Prop() shownitems: ProductPriceItem[] = [];
  @Prop() showMeasurement?: boolean = false;
  @State() weightText = '';
  componentWillLoad() {
    this.composeItems();
  }

  @Watch('item')
  composeItems() {
    if (this.item.description) {
      this.description = this.item.description.split('#bullet').filter(x => x !== '');
    }
    this.showMeasurement = this.item.maxmått !== null || this.item.rulle !== null;
    this.shownitems = [this.item];
    // if (this.item.pricestamps) {
    //   this.shownitems.push({...this.item, priceagent: null, pricesenddirect: null});
    // }
    // if (this.item.priceagent) {
    //   this.shownitems.push({...this.item, pricestamps: null, pricesenddirect: null});
    // }
    // if (this.item.pricesenddirect) {
    //   this.shownitems.push({...this.item, pricestamps: null, priceagent: null});
    // }
    // // Parcels are always in KG. Letter KG must be converted from grams
    // this.weightText = (this.item.what === "parcel") ? this.item.maxweight + 'kg' :
    // (this.item.what === "letter" && this.item.maxweight > 999) ? Math.round(this.item.maxweight/1000) + " kg" : this.item.maxweight + " g";
  }

  render() {
    return (
      <Host>
        {this.shownitems.map(item => (
          <pn-product-card data-productid={item.id}>
            <pn-illustration slot="illustration" illustration={this.item.illustration}></pn-illustration>
            <div slot="title">
              <h2>{item.name} </h2>

              {this.item.highestrankusp ? (
                this.item.highestrankusp === 'Billigast' ? (
                  <pn-titletag slot="Billigast" icon={box_label}>
                    {this.item.highestrankusp}
                  </pn-titletag>
                ) : (
                  <pn-titletag slot="Snabbast" icon={bolt} color="blue700">
                    {this.item.highestrankusp}
                  </pn-titletag>
                )
              ) : null}
            </div>
            <div slot="content">
              <div class="content">
                {this.item.description ? (
                  <div class="description">
                    {this.description.map(desc => (
                      <li>{desc}</li>
                    ))}
                  </div>
                ) : null}
                {this.item.info ? <div class="description">{this.item.info}</div> : null}
              </div>
            </div>
            {this.item.note ? (
              <small slot="note">
                <p>{this.item.note}</p>
              </small>
            ) : null}
            {this.item.additionalusp ? (
              <div slot="additionalUSP">
                {/* {this.Usp1 ? (<span>{this.Usp1}</span>) : null } 
                 {this.Usp2 ? (<span>{this.Usp2}</span>) : null } 
                 {this.Usp3 ? (<span>{this.Usp3}</span>) : null } */}
              </div>
            ) : null}
            {this.showMeasurement ? <pn-product-card-info paket={this.item.maxmått} rulle={this.item.rulle}></pn-product-card-info> : null}
            <div slot="cardprice">
              {this.item.pricesenddirect ? (
                <pn-product-card-price
                  slot="sendDirectPrice"
                  label={state.i18n.senddirectcta}
                  amount={this.item.pricesenddirect + ''}
                  currency={state.market.currency}
                  url={sendDirectUrl}
                  service={this.item.name + '-portal'}
                ></pn-product-card-price>
              ) : null}
              {this.item.pricestamps ? (
                <pn-product-card-price
                  slot="stampPrice"
                  label={state.i18n.stampshopcta}
                  amount={this.item.pricestamps + ''}
                  currency={state.market.currency}
                  url={stampShopUrl}
                  service={this.item.name + '-eshop'}
                ></pn-product-card-price>
              ) : null}
            </div>
          </pn-product-card>
          // <pn-product-tile>
          //   <pn-illustration slot="illustration" illustration={ item.illustration }></pn-illustration>
          //   <div slot="content">
          //     <div class="content">
          //       <h3>{item.name}</h3>
          //       {(item.description) ? (<div class="description">{item.description}</div>) : null}
          //       {(item.info) ? (<div class="description">{item.info}</div>) : null}
          //     </div>
          //   </div>

          //   { item.maxweight ? (<pn-product-tile-info label={state.i18n.maxweightlabel} text={this.weightText}></pn-product-tile-info>) : null }
          //   {/* { item.maximummeasurements ? (<pn-product-tile-info label={state.i18n.maxmeasurementlabel} text={item.maximummeasurements}></pn-product-tile-info>) : null } */}
          //   { item.pricestamps ? (<pn-product-tile-price slot="price" label={state.i18n.stampshopcta} amount={item.pricestamps+''} currency={ state.market.currency }></pn-product-tile-price>) : null }
          //   {/* { item.priceagent ? (<pn-product-tile-price slot="price" label="" amount={item.priceagent+''} currency={ state.market.currency } url="https://shop.postnord.se/ebutik/default.aspx"></pn-product-tile-price>) : null } */}
          //   { item.pricesenddirect ? (<pn-product-tile-price slot="price" label={state.i18n.senddirectcta} amount={item.pricesenddirect+''} currency={ state.market.currency } url="https://portal.postnord.com/skickadirekt/"></pn-product-tile-price>) : null }
          //   { item.note ? (<small slot="note"><p>{item.note}</p></small>) : null }
          // </pn-product-tile>
        ))}
      </Host>
    );
  }
}
